<template>
  <v-tooltip
    top
    class="help-tooltip"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        small
        class="help-tooltip__icon"
        v-on="on"
      >
        help
      </v-icon>
    </template>
    <span><slot /></span>
  </v-tooltip>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.help-tooltip {

  &__icon {
    cursor: help;
    vertical-align: text-top;
    padding: 4px;
    border-radius: 150px;
    float: right;

    &:hover {
      background: #ffffff26;
    }
  }
}
</style>
